module.exports = __webpack_public_path__ + "img/PO-bg.06c9e689.png";